export const GET_BUSINESSES = 'GET_BUSINESSES';
